import { useFsFlag } from "@flagship.io/react-sdk";

const SHOW_DEPOSIT_FLAG_KEY = "show_deposit_payment_terms";

export const useShowDepositFlag = () => {
	const showDepositFlag = useFsFlag(SHOW_DEPOSIT_FLAG_KEY);
	return showDepositFlag.getValue(undefined);
};
